import { render, staticRenderFns } from "./show-page.vue?vue&type=template&id=794e56aa&scoped=true&"
import script from "./show-page.vue?vue&type=script&lang=js&"
export * from "./show-page.vue?vue&type=script&lang=js&"
import style0 from "./show-page.vue?vue&type=style&index=0&id=794e56aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794e56aa",
  null
  
)

export default component.exports